import { DeviceRef, IfRef } from "./Refs";
import { DeviceSet, SerialNumberInfo, NetBiosNameInfo, SystemNameInfo, HostNameInfo } from "./DeviceSet";
import { Device } from "./Device";
import { IfTable, IfEntry } from "../InfoSets/IfTable";
import { ResolveResult } from "./Keys";

export interface RefResolver {
	Resolve(deviceRef: DeviceRef);
	ResolveRef(ifRef: IfRef);
}

export class DefaultRefResolver implements RefResolver {
	private _Devices: DeviceSet;

	constructor(deviceSet: DeviceSet) {
		this._Devices = deviceSet;
	}

	public Resolve(deviceRef: DeviceRef) :void {
		if (deviceRef.Device == null) {
			deviceRef.Device = deviceRef.DeviceKey.Resolve(this._Devices);
		}
	}

	public ResolveRef(ifRef: IfRef): void {
		if (ifRef.Device == null || ifRef.IfEntry == null) {
			var device: Device = null;
			var ifEntry: IfEntry = null;
			var resolveResult: ResolveResult = ifRef.IfKey.Resolve(this._Devices);
			if (resolveResult.Result) {
				ifRef.Device = resolveResult.Device;
				ifRef.IfEntry = resolveResult.IfEntry;
			}
		}
	}
}
